/**
 * Pure game type detection extracted from gameTypeUtils — no Supabase dependency.
 * The full gameTypeUtils also fetches game types from the DB; this module only
 * contains the stateless detection logic used by the matchmaking engine.
 */

export const detectGameType = (team1Players, team2Players) => {
  if (!team1Players || !team2Players) {
    console.warn('Invalid team data provided to detectGameType');
    return { id: 6, name: 'Unbalanced Doubles' };
  }

  const allPlayers = [...team1Players, ...team2Players];
  const totalPlayers = allPlayers.length;

  if (totalPlayers === 2) {
    const player1 = allPlayers[0];
    const player2 = allPlayers[1];

    if (!player1.gender || !player2.gender) {
      return { id: 7, name: 'Unbalanced Singles' };
    }

    const gender1 = player1.gender.toLowerCase();
    const gender2 = player2.gender.toLowerCase();

    if (gender1 === 'male' && gender2 === 'male') return { id: 4, name: 'Mens Singles' };
    if (gender1 === 'female' && gender2 === 'female') return { id: 5, name: 'Womens Singles' };
    return { id: 7, name: 'Unbalanced Singles' };
  }

  if (totalPlayers === 4) {
    const team1Genders = team1Players.map(p => p.gender?.toLowerCase() ?? null).filter(Boolean);
    const team2Genders = team2Players.map(p => p.gender?.toLowerCase() ?? null).filter(Boolean);

    if (team1Genders.length !== 2 || team2Genders.length !== 2) {
      return { id: 6, name: 'Unbalanced Doubles' };
    }

    const team1HasMixed = team1Genders.includes('male') && team1Genders.includes('female');
    const team2HasMixed = team2Genders.includes('male') && team2Genders.includes('female');

    if (team1HasMixed && team2HasMixed) return { id: 1, name: 'Mixed Doubles' };

    const allMale = allPlayers.every(p => p.gender?.toLowerCase() === 'male');
    if (allMale) return { id: 2, name: 'Mens Doubles' };

    const allFemale = allPlayers.every(p => p.gender?.toLowerCase() === 'female');
    if (allFemale) return { id: 3, name: 'Womens Doubles' };

    const team1AllMale = team1Genders.every(g => g === 'male');
    const team2AllMale = team2Genders.every(g => g === 'male');
    const team1AllFemale = team1Genders.every(g => g === 'female');
    const team2AllFemale = team2Genders.every(g => g === 'female');

    if ((team1AllMale && team2HasMixed) || (team2AllMale && team1HasMixed)) {
      return { id: 6, name: 'Mens vs Mixed Doubles' };
    }
    if ((team1AllFemale && team2HasMixed) || (team2AllFemale && team1HasMixed)) {
      return { id: 8, name: 'Womens vs Mixed Doubles' };
    }
    if ((team1AllMale && team2AllFemale) || (team2AllMale && team1AllFemale)) {
      return { id: 9, name: 'Mens vs Womens Doubles' };
    }

    return { id: 6, name: 'Mens vs Mixed Doubles' };
  }

  console.warn(`Invalid number of players: ${totalPlayers}`);
  return { id: 6, name: 'Unbalanced Doubles' };
};
